import React, { useRef, useState, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import "../../case.scss"
import { Button, Upload, Form, Col } from "antd";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useCompanyModel } from "../companyModel";
import BraftEditor, { EditorState, ExtendControlType } from "braft-editor";
import { ContentUtils } from 'braft-utils';
import 'braft-editor/dist/index.css'
import 'braft-extensions/dist/table.css'
import { __FormInput as FormInput } from "@/components/YhFormBox/item/FormInput";
import { __FormTextArea as FormTextArea } from "@/components/YhFormBox/item/FormTextArea";
import { __FormFileImage as FormFileImage } from "@/components/YhFormBox/item/FormFileImage";
import { __FormSwitch as FormSwitch } from "@/components/YhFormBox/item/FormSwitch";
import useGlobalModel from "@/model/globalModel";
import { COSUploadFile } from "@/utils/uploadFile";
import { RcCustomRequestOptions } from "antd/lib/upload/interface";
export const DetailsBox = () => {
    const { addFormVal,
        addMd5FormVal,
        editFormVal,
        editMd5FormVal,
        insertDetail,
        editDetail,
        setAddMd5FormVal,
        setEditMd5FormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        setSelectedRow,
        setSelectedRowKeys,
        loadData,
    } = useCompanyModel();
    const { user } = useGlobalModel()
    const { selectedNavId, getSelectedNavState, findNav, replaceNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode } = detailsInfo;
    const [content, setContent] = useState<EditorState>()
    useEffect(() => {
        if (!Object.keys(editFormVal).length && mode === "edit") {
            getDetailEditOne(id, mode)
        }
    }, [id, mode])

    useEffect(() => {
        setContent(BraftEditor.createEditorState(mode === "add" ? addFormVal?.content : editFormVal?.content))
    }, [addFormVal.content, editFormVal.content])

    useEffect(() => {
        return () => {
            !findNav("4-1-1") && resetAddCatch(mode) && clean();
            !findNav("4-1-2") && resetEditCatch(mode) && clean();
        }
    }, [selectedNavId])
    const formRef = useRef<IYhFormRef>();
    const onSetFieldsValue = (formValues: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === "add" ? setAddMd5FormVal(formValues.image) : setEditMd5FormVal(formValues.image)
    }

    const onSubmit = () => {
        formRef.current?.validateFields().then(async (res: any) => {
            const formData = await formRef.current?.validateFields();
            let { status, homeFlag, ...params } = res
            const list = mode === "add" ? addMd5FormVal.map(imgMd5 => ({ imgMd5 })) : editMd5FormVal.map(imgMd5 => ({ imgMd5 }))
            const data = {
                ...params,
                status: status ? 1 : 0,
                homeFlag: homeFlag ? 1 : 0,
                content: content.toHTML(),
                list,
                type: "company",
            }

            if (mode === "add") {
                const retData = await insertDetail(data)
                if (retData) {
                    globalPrompt("message", { text: "公司新闻新增成功", type: "success" })
                    resetAddCatch()
                    goBack();
                }
            } else {
                const retData = await editDetail({
                    ...data,
                    id,
                    updateUser: user.userName,
                })
                if (retData) {
                    globalPrompt("message", { text: "公司新闻编辑成功", type: "success" })
                    resetEditCatch()
                    goBack();
                }
            }
        })
    }

    const clean = () => {
        setSelectedRow([])
        setSelectedRowKeys([])
        formRef.current?.resetFields();
    }
    const goBack = async () => {
        clean()
        await loadData()
        replaceNav(selectedNavId, "4-1")
    }



    const onUpload = (param: any) => {
        COSUploadFile({
            options: param as unknown as RcCustomRequestOptions,
            onSuccess: (url, md5) => {
                param.success({
                    url: url,
                    meta: {
                        id: md5,
                        title: param.file.name,
                        alt: param.file.name,
                        loop: true, // 指定音视频是否循环播放
                        autoPlay: true, // 指定音视频是否自动播放
                        controls: true, // 指定音视频是否显示控制栏
                        poster: '', // 指定视频播放器的封面
                    }
                })

            },
            // prefix: 'wms',
            onError: (error) => console.log(error),
            // onMD5Progress: setPercent({ ...percent, parsePercent: parseInt(Number(progress) * 100 + '') }),
            onProgress: (info) => param.progress(Number(info.percent) * 100)
        })
    }
    const onEditorChange = async (editorState: EditorState) => {
        setContent(editorState)
    }
    return <YhBox title="公司新闻详情">
        <YhForm formRef={formRef} labelCol={{ span: 6 }} items={[]} formValues={mode === "add" ? {
            ...addFormVal,
            createUser: user.userName,
            // content: BraftEditor.createEditorState(addFormVal?.content),
        } : {
            ...editFormVal,
            // content: BraftEditor.createEditorState(editFormVal?.content),
        }
        } >
            <div style={{ display: "flex" }}>
                <div className="form-left">
                    <Col span={24} key="title">
                        <FormInput
                            type={FormItemTypeEnum.Input}
                            fieldLabel="文章标题"
                            fieldName="title"
                            rules={[{ required: true, message: "请输入文章标题" }]}
                        />
                    </Col>
                    <Col span={24} key="keywords">
                        <FormInput
                            type={FormItemTypeEnum.Input}
                            fieldLabel="关键词"
                            fieldName="keywords"
                            rules={[{ required: true, message: "请输入关键词" }]}
                        />
                    </Col>
                    <Col span={24} key="desc">
                        <FormTextArea
                            type={FormItemTypeEnum.TextArea}
                            fieldLabel="描述"
                            fieldName="desc"
                            rules={[{ required: true, message: "请输入描述" }]}
                        />
                    </Col>
                    <Col span={24} key="image">
                        <FormFileImage
                            type={FormItemTypeEnum.FileImage}
                            fieldLabel="图片上传"
                            fieldName="image"
                            rules={[{ required: true, message: "请选择图片" }]}
                            md5List={mode === "add" ? addMd5FormVal : editMd5FormVal}
                            onSetFieldsValue={onSetFieldsValue}
                        />
                    </Col>
                    <Col span={24} key="createUser">
                        <FormInput
                            type={FormItemTypeEnum.Input}
                            fieldLabel="创建人"
                            fieldName="createUser"
                            disable={true}
                        />
                    </Col>
                    <Col span={24} key="createTime">
                        <FormInput
                            type={FormItemTypeEnum.Input}
                            fieldLabel="创建时间"
                            fieldName="createTime"
                            disable={true}
                        />
                    </Col>
                    <Col span={24} key="status">
                        <FormSwitch
                            type={FormItemTypeEnum.Switch}
                            fieldLabel="置顶"
                            fieldName="status"
                        />
                    </Col>
                    <Col span={24} key="homeFlag">
                        <FormSwitch
                            type={FormItemTypeEnum.Switch}
                            fieldLabel="推荐到首页"
                            fieldName="homeFlag"
                        />
                    </Col>
                    <div className="form-btn">
                        <Button type="link" shape="round" onClick={onSubmit}>发布</Button>
                        <Button type="link" shape="round" onClick={goBack}>返回</Button>
                    </div>
                </div>
                <div className="img-right">
                    <Col span={24} key="content">
                        {/* <Form.Item
                            name="content"
                            labelCol={{
                                span: 3
                            }}
                            required={true}
                            rules={[
                                { required: true, message: "请输入内容" }
                            ]}
                        > */}
                        <BraftEditor
                            // readOnly={editModel === 'look'}
                            // style={{ border: "1px solid #ccc", borderRadius: "6px" }}
                            value={content}
                            className="my-editor"
                            media={{
                                uploadFn: onUpload
                            }}
                            onChange={value => onEditorChange(value)}
                            placeholder="请输入正文内容"
                        />
                        {/* </Form.Item> */}
                    </Col>
                </div>
            </div>
        </YhForm>
    </YhBox >
}